export default __webpack_public_path__ + "static/media/game_process.f5fb877c.mp4";